import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  AdditionalDocumentsFormType,
  getAdditionalDocumentsSchema,
} from 'modules/client/common/forms/additionalDocumentsForm';
import {
  placeOfBirthSchema,
  PlaceOfBirthFormType,
} from 'modules/client/common/forms/placeOfBirthForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { BaseActivityFormType, baseActivitySchema } from './baseActivityForm';
import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import { ContactsFormType, getContactsSchema } from './contactsForm';
import {
  IdentityDocumentFormType,
  getIdentityDocumentSchema,
} from './identityDocumentForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import {
  BaseLegalClientHeadPositionFormType,
  getBaseLegalClientHeadPositionFormSchema,
} from './positionInCompany';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientFirstHeadFormType
  extends BaseActivityFormType,
    ContactsFormType,
    BaseLegalClientHeadPositionFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    IdentityDocumentFormType,
    PepConnectionFormType,
    AdditionalDocumentsFormType,
    ReasonChangeFormType,
    PlaceOfBirthFormType {}

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientFirstHeadFormType> => {
  const isFinance = isFinanceProject();
  const isGlobal = isGlobalProject();

  return object()
    .concat(getContactsSchema(t))
    .concat(getPersonalDataSchema(t))
    .concat(citizenshipsSchema)
    .concat(baseActivitySchema)
    .concat(getTaxResidencesSchema())
    .concat(applySchema(isFinance, registrationAddressSchema))
    .concat(applySchema(isGlobal, placeOfBirthSchema))
    .concat(residentialAddressWithFilesSchema)
    .concat(getIdentityDocumentSchema(isGlobal))
    .concat(reasonChangeSchema)
    .concat(getBaseLegalClientHeadPositionFormSchema(t))
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(getAdditionalDocumentsSchema());
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientFirstHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientFirstHeadFormType>;
